module.exports = __webpack_public_path__ + "static/img/02-external-tool.c7a3bad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lti-assignment-guide/02-external-tool.png
// module id = ggfo
// module chunks = 1